import { CommonModule, DatePipe, NgIf } from '@angular/common'
import { Component, Input, OnChanges } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ButtonComponent } from '@progress/kendo-angular-buttons'
import { DateInputCustomFormatPlaceholder, DatePickerComponent } from '@progress/kendo-angular-dateinputs'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, RemoveCommandDirective, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { TextBoxDirective } from '@progress/kendo-angular-inputs'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { OutsideActivity } from '../../../../models/repEditorModels'
import { Utilities } from '../../../../utilities/utilities'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'
import { AdminOnlyDirective } from '../shared/admin-only.directive'

@Component({
    selector: 'gd-rep-editor-outside-activity',
    templateUrl: './rep-editor-outside-activity.component.html',
    styleUrls: ['./rep-editor-outside-activity.component.scss'],
    imports: [
        CommonModule,
        GridComponent,
        DataBindingDirective,
        ToolbarTemplateDirective,
        GridToolbarFocusableDirective,
        AddCommandDirective,
        ButtonComponent,
        ColumnComponent,
        EditTemplateDirective,
        TextBoxDirective,
        FormsModule,
        ReactiveFormsModule,
        CellTemplateDirective,
        DatePickerComponent,
        CommandColumnComponent,
        FocusableDirective,
        EditCommandDirective,
        NgIf,
        RemoveCommandDirective,
        SaveCommandDirective,
        CancelCommandDirective,
        DatePipe,
        AdminOnlyDirective
    ]
})
export class RepEditorOutsideActivityComponent
  extends GridEditorBaseComponent
  implements OnChanges
{
  @Input() override repId: number = 0
  outsideActivity: OutsideActivity[]
  public asDateInput = (value) =>
    Utilities.asType<DateInputCustomFormatPlaceholder>(value)

  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  ngOnChanges() {
    this.checkGridState()

    if (!this.repState.repOutsideActivities) {
      this.initGrid()
    }
  }

  initGrid() {
    this.clientService
      .getOutsideActivityForRep({ repId: this.repId })
      .subscribe((response) => {
        this.repState.repOutsideActivities = response.map(
          (oa) => new OutsideActivity(oa),
        )
      })
  }

  public addHandler({ sender }) {
    const newOutsideActivity = new OutsideActivity(null)
    newOutsideActivity.repId = this.repId
    newOutsideActivity.active = true
    this.addHandlerShared({ sender }, newOutsideActivity)
  }

  public saveHandler({ sender, rowIndex, formGroup, isNew }): void {
    const outsideActivity = new OutsideActivity(formGroup.value)
    this.clientService
      .submitOutsideActivityUpdate(outsideActivity)
      .subscribe(() => {
        sender.closeRow(rowIndex)
        this.initGrid()
      })
  }

  public removeHandler({ dataItem }) {
    const itemToRemove = new OutsideActivity(dataItem)
    itemToRemove.active = false
    this.clientService
      .submitOutsideActivityUpdate(itemToRemove)
      .subscribe(() => {
        this.initGrid()
      })
  }

  public createFormGroup(outsideActivity: OutsideActivity): UntypedFormGroup {
    return this.formBuilder.group({
      outsideActivityId: outsideActivity.outsideActivityId,
      repId: outsideActivity.repId,
      businessName: [outsideActivity.businessName, Validators.required],
      role: outsideActivity.role,
      description: outsideActivity.description,
      outsideIa: outsideActivity.outsideIa,
      outsideIns: outsideActivity.outsideIns,
      beginDate: outsideActivity.beginDate,
      endDate: outsideActivity.endDate,
      active: outsideActivity.active,
    })
  }
}
